import { css } from '@emotion/css';
import { Dimensions4 } from '@efexteam/design-tokens';

const confirmPasswordContainer = css({
  '& .MuiFormControl-root': {
    marginTop: Dimensions4,
  },
});

const PasswordInputStyles = {
  confirmPasswordContainer,
};

export default PasswordInputStyles;
